import React, { FC, useCallback } from 'react';
import { useFormContext } from 'react-hook-form';

import InputField from '@buyside/components/presentation/Fields/inputField';

import {
  determineIsSubunitCurrency,
  determineParentCurrencyCode,
  IdeaFormInput
} from '@buyside/util/researchSubmission';

import { Maybe } from '@interfaces/graphql-typings';

import styles from '../positionsStyles.scss';

const PriceTargetField: FC<{
  currencyCode: string;
  disabled: boolean;
  index: number;
  latestPrice: Maybe<number>;
}> = ({ currencyCode, disabled, index, latestPrice }) => {
  const { setValue } = useFormContext<IdeaFormInput>();

  const onChangeCallback = useCallback(
    (priceTarget: string) => {
      if (!latestPrice) return;

      const direction = priceTarget ? (Number(priceTarget) > latestPrice ? 'long' : 'short') : '';

      return setValue(`positions.${index}.direction`, direction, {
        shouldDirty: true,
        shouldTouch: true,
        shouldValidate: true
      });
    },
    [index, latestPrice, setValue]
  );

  const generateSubunitCurrencyHelperElement = useCallback(
    (priceTarget: string) => {
      if (priceTarget && determineIsSubunitCurrency(currencyCode))
        return (
          <label className={styles.positionAssetSubunitCurrencyLabel}>
            ({(Number(priceTarget) * 100).toFixed(2)} {currencyCode})
          </label>
        );

      return null;
    },
    [currencyCode]
  );

  return (
    <InputField
      disabled={disabled}
      endAdornment={determineParentCurrencyCode(currencyCode)}
      generateHelperElement={generateSubunitCurrencyHelperElement}
      inputProps={{
        min: 0,
        step: 0.01
      }}
      label="Target Price"
      name={`positions.${index}.priceTarget`}
      onChangeCallback={onChangeCallback}
      type="number"
    />
  );
};

export default PriceTargetField;
